import { required, requiredIf } from 'vuelidate/lib/validators';
import getAcknowledgeData from '@/app/utils/toolkit/business-rules/pension-establishment/pensionEligibilityAcknowledgements';

export default {
  name: 'pension-eligibility',
  computed: {
    reasons() {
      const { member } = this.$store.getters['toolkit/getItemData'].requirements;
      if (member.age >= 60 && member.age < 65) {
        return [
          'The pension will be a transition to retirement pension',
          'Permanently retired',
          'Ended a paid work arrangement after turning 60',
          'Suffering from a terminal medical condition',
          'Permanently incapacitated',
          'other',
        ];
      }
      if (member.age < member.preservationAge) {
        return [
          'Suffering from a terminal medical condition',
          'Permanently incapacitated',
          'other',
        ];
      }
      if (member.age >= member.preservationAge && member.age < 60) {
        return [
          'The pension will be a transition to retirement pension',
          'Permanently retired',
          'Suffering from a terminal medical condition',
          'Permanently incapacitated',
          'other',
        ];
      }
      return [];
    },
    pensioner() {
      return this.getItem.requirements.member.name;
    },
    pensionerAge() {
      return `${this.getItem.requirements.member.age} years old.`;
    },
    preservationAge() {
      return `${this.getItem.requirements.member.preservationAge} years old.`;
    },
    pensionStartDate() {
      return this.getItem.requirements.startDate;
    },
    acknowledgeRequired() {
      return (this.otherReasons !== '');
    },
    acknowledgeInfo() {
      return getAcknowledgeData(this.otherReasons);
    },
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    otherReasons: {
      get() {
        return this.getItem.requirements.eligibility.reasons;
      },
      async set(value) {
        if (!value.includes('other')) {
          await this.setItem({ requirements: { eligibility: { reasons: value, otherReason: 'I have sufficient unrestricted non-preserved superannuation to do so, having met a condition of release in the past.', acknowledge: false } } });
        } else {
          await this.setItem({ requirements: { eligibility: { reasons: value } } });
        }

        await this.setItem({
          setup: {
            howMuch: '',
            accumulationKnown: '',
            taxComponentKnown: '',
            transferBalanceCapKnown: '',
            part: '',
          },
        });
      },
    },
    otherReason: {
      get() {
        return this.getItem.requirements.eligibility.otherReason;
      },
      set(value) {
        this.setItem({ requirements: { eligibility: { otherReason: value } } });
      },
    },
    acknowledge: {
      get() {
        return this.getItem.requirements.eligibility.acknowledge === true;
      },
      set(value) {
        this.setItem({ requirements: { eligibility: { acknowledge: value } } });
      },
    },
  },
  methods: {
    async setItem(item) {
      await this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations: {
    otherReason: {
      required: requiredIf(function otherRequired() {
        if (this.otherReasons === 'other') {
          return true;
        }
        return false;
      }),
    },
    otherReasons: {
      required,
    },
    acknowledge: {
      mustBeTrue: value => value === true,
    },
  },
};
